import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

class SubLevOne extends Component {
    render() {
        const { Bordered, ServiceDesc, ServiceName, ButtonText } = this.props;
        return (
            <div className={"col-12 col-sm-4 col-md-4 inner-column " + Bordered}>
                <div className="innner-colums">
                    <h5 className="bold deep-blue-text">{ServiceName}</h5>
                    <p>{ServiceDesc}</p>
                    <NavLink to="/" className="gray-bordered-button-sm">{ButtonText}</NavLink>
                </div>
            </div>
        );
    }
}

class LevelTwoOne extends Component {
    render() {
        return (
            <div className="card half-card">
                <span className='text-uppercase'>{this.props.tagName}</span>
                <div className="row">
                    <SubLevOne ServiceName="Investment Banking" ButtonText="Learn more"
                        ServiceDesc="The FSDH Investment Banking Division was set up for the purpose of creating capital for our clients, whilst ensuring that they achieve their strategic goals." />

                    <SubLevOne ServiceName="Wealth Management" ButtonText="Learn more" Bordered="bordered-column"
                        ServiceDesc="At FSDH Merchant Bank, we see our clients’ investments as part of their overall wealth plan, so we work with them to develop the right financial..." />

                    <SubLevOne ServiceName="Corporate Banking" ButtonText="Learn more"
                        ServiceDesc="Our Corporate Banking Division was created to strategically manage our Corporate Clients in various sectors of the Nigerian Economy." />
                </div>
            </div>
        );
    }
}

export default LevelTwoOne;